import axios from 'axios'

function sha256(plain) {
	return crypto.subtle.digest("SHA-256", new TextEncoder().encode(plain));
}

function base64(bytes) {
	return btoa(String.fromCharCode(...bytes))
	  .replace(/=/g, '')
	  .replace(/\+/g, '-')
	  .replace(/\//g, '_')
  }

function generateCodeVerifier() {
	return base64(crypto.getRandomValues(new Uint8Array(96)))
}

class spotifyApiClient {
	constructor() {
		this.client_id = '95e5bd2d9d794956a426ac60aea4a399'
		this.api_base = 'https://api.spotify.com/v1/'
		this.scope = 'playlist-read-private user-top-read user-library-read'
		this.redirect_uri = `${window.location.protocol}//${window.location.host}/`
		this.code_verifier = this.getCodeVerifier()
		this.access_token = this.storageGet('access_token')
		this.refresh_token = this.storageGet('refresh_token')
		this.code_verifier = this.storageGet("code_verifier")
	}
	getCodeVerifier() {
		let code_verifier = this.storageGet("code_verifier")
		if (!code_verifier) {
			code_verifier = generateCodeVerifier()
			this.storagePut("code_verifier", code_verifier)
		}
		return code_verifier
	}
	createCodeChallenge(verifier) {
		return sha256(verifier).then(hashed => {
			return base64(new Uint8Array(hashed))
		});
	}
	storageGet(key) {
		return window.localStorage.getItem(key)
	}
	storagePut(key, value) {
		window.localStorage.setItem(key, value)
	}
	refreshAuthentication() {
		const params = new URLSearchParams()
		params.append('grant_type', 'refresh_token')
		params.append('client_id', this.client_id)
		params.append('refresh_token', this.refresh_token)
		return axios.post('https://accounts.spotify.com/api/token', params, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then((response) => {
			this.access_token = response.data.access_token
			this.storagePut('access_token', this.access_token)
			return response
		}).catch((error) => {
			throw error
		})
	}
	createAuthUrl() {
		return this.createCodeChallenge(this.code_verifier).then(code_challenge => {
			let query = new URLSearchParams()
			query.append("client_id", this.client_id)
			query.append("response_type", "code")
			query.append("redirect_uri", this.redirect_uri)
			query.append("scope", this.scope)
			query.append("code_challenge_method", "S256")
			query.append("code_challenge", code_challenge)
			return `https://accounts.spotify.com/authorize?${query.toString()}`
		})
	}
	authenticate(code) {
		const params = new URLSearchParams()
		params.append('grant_type', 'authorization_code')
		params.append('code', code)
		params.append('redirect_uri', this.redirect_uri)
		params.append('client_id', this.client_id)
		params.append('code_verifier', this.code_verifier)
		return axios.post('https://accounts.spotify.com/api/token', params, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then((response) => {
			this.access_token = response.data.access_token
			this.refresh_token = response.data.refresh_token
			this.storagePut('access_token', this.access_token)
			this.storagePut('refresh_token', this.refresh_token)
		})
	}
	signOut() {
		this.access_token = null
		this.refresh_token = null
		this.storagePut("access_token", this.access_token)
		this.storagePut("refresh_token", this.refresh_token)
	}
	getUserPlaylists(limit, offset) {
		return this.get(`me/playlists?limit=${limit}&offset=${offset}`)
	}
	getPlaylistTracks(playlistId, limit, offset) {
		return this.get(`playlists/${playlistId}/tracks?limit=${limit}&offset=${offset}`)
	}
	getArtistAlbums(artistId, limit, offset) {
		return this.get(`artists/${artistId}/albums?limit=${limit}&offset=${offset}`)
	}
	getByURL(url) {
		return this.executePaged(url)
	}
	searchArtists(searchText, offset) {
		return this.search(searchText, "artist", offset)
	}
	search(searchText, searchType, offset) {
		offset = offset || 0
		let q = encodeURIComponent(searchText)
		let type = encodeURIComponent(searchType)
		return this.executePaged(`https://api.spotify.com/v1/search?q=${q}&type=${type}&limit=50&offset=${offset}`)
	}
	getTopArtists(limit, offset) {
		return this.get(`me/top/artists?limit=${limit}&offset=${offset}`)
	}
	getUserProfile() {
		return this.get("me")
	}
	get(endpoint) {
		return this.exeucteGet(endpoint).then((response) => {
			return response
		}).catch((error) => {
			if (error.response?.status === 401) {
				return this.refreshAuthentication()
					.then(_ => this.exeucteGet(endpoint))
			} else {
				throw error
			}
		})
	}
	exeucteGet(endpoint) {
		return axios.get(this.api_base + endpoint, {
			headers: {
				authorization: `Bearer ${this.access_token}`
			}
		})
	}
}
export default spotifyApiClient
